import React from 'react'

import Icon from '@/icons'
import BusinessSection from '@/business-section'
import { isMobile } from 'u/common'

const SectionDesigned = ({ gray }) => {
  return (
    <BusinessSection
      title="Designed for you"
      subtitle="Enabling beauty pageants to work in a simpler smarter way"
      gray={gray}
    >
      <div className="flex justify-center">
        <ul className="list f8 f7-m f6-l mv0">
          <ListItem icon="global-platform" text="The leading global platform for beauty pageants" />
          <ListItem icon="online-awareness" text="Maximise your online awareness with zero cost" />
          <ListItem icon="revenue-streams" text="Maximise your online revenue streams" />
          <ListItem icon="global-audience" text="Reach your global audience" />
          <ListItem icon="instant-access" text="Get instant access to the best digital tools available" />
        </ul>
      </div>
    </BusinessSection>
  )
}

function ListItem({ icon, text }) {
  return (
    <li className="mb4 flex items-center">
      <Icon
        icon={icon}
        width={isMobile ? '80px' : '100px'}
        height={isMobile ? '48px' : '60px'}
        className="mr3 mr4-m flex-shrink-0"
      />
      {text}
    </li>
  )
}

export default SectionDesigned



// WEBPACK FOOTER //
// ./src/components/section-designed/section-designed.js